import { Button, Tooltip } from '@sib/ui';
import type { DetailsViewActionConfig } from './DetailsView.types';

export const DetailsViewActionButton = ({
  label,
  onClick,
  variant,
  icon,
  disabled = false,
  disabledTooltip,
}: DetailsViewActionConfig) => {
  const button = (
    <Button
      type="button"
      variant={variant}
      disabled={disabled}
      onClick={onClick}
    >
      {icon}
      {label}
    </Button>
  );

  if (!disabled || !disabledTooltip) return button;

  return (
    <Tooltip
      content={disabledTooltip}
      TooltipTriggerProps={{ asChild: true }}
      TooltipContentProps={{
        variant: 'secondary',
        className: 'max-w-[300px] text-left',
      }}
    >
      <span className="inline-flex">{button}</span>
    </Tooltip>
  );
};
